import React, { Component } from 'react'
import {Row, Image, Col, Form} from 'react-bootstrap'
import '../../stylesheets/option.css'
import checkmark from '../../images/icons/selected.svg'
import bg1 from '../../images/icons/bg_1.svg'
import bg2 from '../../images/icons/bg_2.svg'
import bg3 from '../../images/icons/bg_3.svg'

class OtherOption extends Component{

    constructor(props)
    {
        super(props)
        this.state = {
            mouseOver: false,
            otherText: ''
        }
    }

    handleSelect = (e) => {
        e.preventDefault()
        this.props.onValue(this.props.optionData, this.state.otherText == ''?"OTHER":this.state.otherText)
        this.props.onClick(this.props.optionData, this.props.section)

    }


    handleChange = (e) =>
    {
        e.preventDefault()
        e.stopPropagation()
        this.props.onValue(this.props.optionData, e.target.value)
        this.setState({otherText: e.target.value})
    }

    render()
    {
        let style = {}
        let bgimg = bg1
        if(this.props.selected)
        {
            style = {"filter":"invert(1)"}
            bgimg = [bg1, bg2, bg3][this.state.otherText.length%3];
        }
        return (
            <Col xs={{span: 6, offset:0}} sm={{span: 4, offset:0}}  md={{span: 3, offset:0}} lg={{span: 2, offset:0}}onMouseOver={() => this.setState({mouseOver: true})} onMouseLeave={() => this.setState({mouseOver: false})}>
                <Col xs={12} className="option-wrapper">                    
                    {this.props.selected && <img src={checkmark} style={{"height": "20px", "position":"absolute", "top":"0", "right": "0"}}></img>}
                    <Row className='justify-content-md-center'>
                        <Col xs={12} onClick={this.handleSelect} style={{display:'flex'}}>
                            {this.state.mouseOver && <img src={bgimg} style={{"position":"absolute", "top":"-1rem", "left": "0", "opacity": "0.3"}} fluid></img>}
                            {this.props.selected && <img src={bgimg} style={{"position":"absolute", "top":"-1rem", "left": "0"}} fluid></img>}
                            <Image className="option-img" src={this.props.optionData.image} style={style} fluid></Image>
                        </Col>
                        <p className="col-12">{this.props.optionData.text}</p>
                        {this.props.selected && 
                        <>
                        <Form.Control
                        //  defaultValue={this.props.text} 
                         placeholder={this.props.optionData.instruction ? this.props.optionData.instruction : 'type here...'} onChange={this.handleChange} style={{height:'2rem', fontSize:'0.8rem', width:'max-content', fontFamily:'sofia-pro', borderColor:'#000'}} className="question-other-input"></Form.Control>
                         </>
                         }
                    </Row>
                </Col>
            </Col>
        )
    }
}

export default OtherOption